

export const keys = {
    all: ["organization-data"],

    organizations: (includeAllOption?: boolean) => [
        ...keys.all,
        "organizations", {
            includeAllOption
        }
    ],

    organizationDevices: (
        contextGroupID: number,
        includeChildOrganizations: boolean,
        excludeSatelliteDevices: boolean,
    ) => [
        ...keys.all,
        "organization-devices", {
            contextGroupID,
            includeChildOrganizations,
            excludeSatelliteDevices
        }
    ]
};